import axios from 'axios'
import { useState } from 'react'

import { useMessage } from '~/src/hooks/useMessage'
import { otherRepository } from '~/src/repositories'
import { FileUploadStateProps } from '~/src/types/form'

/**
 * useFileUpload
 * FileUpload hooks
 * @example
 * ```ts
 *  const {
 *  uploadFile,
 *   isFileUpLoading,
 *  handleFileChange,
 *  handleFileDelete, } = useFileUpload(initFileData)
 * ```
 * @category ReactHooks
 * @returns
 */
export const useFileUpload = (initFileData: FileUploadStateProps) => {
  const [uploadFile, setUploadFile] = useState<FileUploadStateProps>(initFileData)
  const [isFileUpLoading, setIsFileUpLoading] = useState(false)
  const { handleOpenWithErrorMessage } = useMessage()

  /**
   * handleFileChange
   * @param file
   */
  const handleFileChange = async (file: File): Promise<void> => {
    try {
      setIsFileUpLoading(true)
      const data = await otherRepository.getDownloadFileUrl()

      await otherRepository.putFileUpload(data.url, file)
      setUploadFile({ filename: file.name, url: data.path })
    } catch (e) {
      if (axios.isAxiosError(e)) {
        handleOpenWithErrorMessage(e.message)
      }
    } finally {
      setIsFileUpLoading(false)
    }
  }

  /**
   * handleFileDelete
   */
  const handleFileDelete = () => {
    setUploadFile(undefined)
  }

  return {
    uploadFile,
    setUploadFile,
    isFileUpLoading,
    handleFileChange,
    handleFileDelete,
  }
}
